// TODO: just keeping this file around as a reference for now

import { supabase } from '@/lib/supabase';

// This script adds Dutch synonyms for existing keywords
async function addKeywordSynonyms() {
  try {
    console.log('Fetching existing keywords...');
    const { data: keywords, error: keywordsError } = await supabase
      .from('keywords')
      .select('*')
      .order('name');

    if (keywordsError) throw keywordsError;
    if (!keywords || keywords.length === 0) {
      console.log('No keywords found. Please add keywords first.');
      return;
    }

    console.log(`Found ${keywords.length} keywords. Adding synonyms...`);

    // Map of keyword names to their synonyms
    const synonymsMap: Record<string, string[]> = {
      // Common Dutch keywords and their synonyms
      ontspanning: ['relaxatie', 'rust', 'kalmte', 'verlichting', 'gemak'],
      meditatie: [
        'bezinning',
        'contemplatie',
        'mindfulness',
        'aandachtstraining',
        'concentratieoefening',
      ],
      stress: ['spanning', 'druk', 'belasting', 'onrust', 'nervositeit'],
      angst: ['vrees', 'bezorgdheid', 'ongerustheid', 'paniek', 'fobie'],
      slaap: ['rust', 'dutje', 'slapen', 'sluimeren', 'nachtrust'],
      ademhaling: [
        'ademen',
        'ademtechniek',
        'ademhalingsoefening',
        'ademwerk',
        'adempauze',
      ],
      focus: [
        'concentratie',
        'aandacht',
        'gerichtheid',
        'toewijding',
        'scherpte',
      ],
      energie: ['vitaliteit', 'kracht', 'levendigheid', 'dynamiek', 'pit'],
      balans: [
        'evenwicht',
        'harmonie',
        'stabiliteit',
        'gelijkmatigheid',
        'symmetrie',
      ],
      mindfulness: [
        'aandachtigheid',
        'bewustzijn',
        'opmerkzaamheid',
        'alertheid',
        'tegenwoordigheid van geest',
      ],
      healing: ['genezing', 'herstel', 'heling', 'therapie', 'behandeling'],
      natuur: ['natuurlijk', 'buitenleven', 'milieu', 'omgeving', 'landschap'],
      geluid: ['audio', 'klank', 'toon', 'geluidseffect', 'sonisch'],
      muziek: ['melodie', 'ritme', 'harmonie', 'compositie', 'lied'],
      yoga: [
        'asana',
        'lichaamshouding',
        'stretching',
        'lichaamsoefening',
        'bewegingsleer',
      ],
      gezondheid: [
        'welzijn',
        'vitaliteit',
        'welbevinden',
        'fitheid',
        'conditie',
      ],
      emotie: ['gevoel', 'stemming', 'gemoedstoestand', 'affect', 'sensatie'],
      bewustzijn: ['besef', 'gewaarwording', 'perceptie', 'inzicht', 'kennis'],
      rust: ['kalmte', 'stilte', 'vrede', 'sereniteit', 'ontspanning'],
      adem: ['ademhaling', 'inademing', 'uitademing', 'ademtocht', 'lucht'],
      hart: [
        'hartslag',
        'hartritme',
        'hartcentrum',
        'hartkracht',
        'hartenergie',
      ],
      liefde: ['genegenheid', 'affectie', 'tederheid', 'warmte', 'compassie'],
      zelfzorg: [
        'eigenliefde',
        'zelfcompassie',
        'zelfrespect',
        'zelfwaardering',
        'zelfaandacht',
      ],
      // New keywords
      loslaten: [
        'vrijlaten',
        'afstand doen',
        'laten gaan',
        'bevrijden',
        'onthechten',
      ],
      inzicht: [
        'begrip',
        'besef',
        'bewustwording',
        'helderheid',
        'verlichting',
      ],
      uitzoomen: [
        'afstand nemen',
        'overzicht krijgen',
        'perspectief',
        'breder kijken',
        'helikopterview',
      ],
    };

    // Process each keyword
    for (const keyword of keywords) {
      const keywordName = keyword.name.toLowerCase();
      const synonyms = synonymsMap[keywordName] || [];

      if (synonyms.length > 0) {
        console.log(
          `Adding ${synonyms.length} synonyms for keyword: ${keywordName}`,
        );

        // Add each synonym
        for (const synonym of synonyms) {
          // Check if synonym already exists
          const { data: existingSynonym, error: checkError } = await supabase
            .from('keyword_synonyms')
            .select('*')
            .eq('keyword_id', keyword.id)
            .eq('synonym', synonym)
            .maybeSingle();

          if (checkError) {
            console.error(`Error checking synonym ${synonym}:`, checkError);
            continue;
          }

          // Only add if it doesn't exist
          if (!existingSynonym) {
            const { error: insertError } = await supabase
              .from('keyword_synonyms')
              .insert([{ keyword_id: keyword.id, synonym }]);

            if (insertError) {
              console.error(`Error adding synonym ${synonym}:`, insertError);
            } else {
              console.log(
                `Added synonym: ${synonym} for keyword: ${keywordName}`,
              );
            }
          } else {
            console.log(
              `Synonym ${synonym} already exists for keyword: ${keywordName}`,
            );
          }
        }
      } else {
        console.log(`No synonyms defined for keyword: ${keywordName}`);
      }
    }

    console.log('Finished adding synonyms!');
  } catch (error) {
    console.error('Error in addKeywordSynonyms:', error);
  }
}

// Run the function when this script is executed directly
// Note: import.meta.main is not available in browser environments
// This script should be run directly with a tool like Deno that supports it
// For now, we'll just export the function
// if (import.meta.url === import.meta.main) {
//   addKeywordSynonyms();
// }

// Export the function so it can be called from elsewhere
export { addKeywordSynonyms };
